import React, { Suspense, useState } from 'react';
import { BrowserRouter as Router, Route, Switch } from 'react-router-dom';
import Footer from 'components/Footer/Footer';
import CssBaseline from '@material-ui/core/CssBaseline';
import Box from '@material-ui/core/Box';
import { Loader } from 'shared';

import { routes } from './routes';
import { menuMobileData } from 'utils/menuMobileData';
import { menuData } from 'utils/menuData';
import logo from 'assets/logos/pff.png';
import logoSmall from 'assets/logos/pff.png';
import process from 'process';
import Header from 'components/Header';
window.process = process;
function App() {
  const [openApplications, setOpenApplications] = useState(false);
  const [openProducts, setOpenProducts] = useState(false);

  const headerProps = {
    menuData: menuData({
      openApplications,
      setOpenApplications,
      openProducts,
      setOpenProducts,
    }),
    menuMobileData,
    logo,
    logoSmall,
  };

  return (
    <Box
      className="App"
      style={{ width: '100%', maxWidth: '100vw', scroll: 'none' }}
    >
      <CssBaseline></CssBaseline>
      <Router>
        <Header {...headerProps} />
        <Suspense fallback={<Loader />}>
          <Switch>
            {routes.map((curr, idx) => (
              <Route key={idx} exact={curr.exact} path={curr.path}>
                {curr.component}
              </Route>
            ))}
          </Switch>
        </Suspense>
        <Footer></Footer>
      </Router>
    </Box>
  );
}

export default App;
